var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Injectable } from '@angular/core';
var GraphTransformService = /** @class */ (function () {
    function GraphTransformService(sanitizer) {
        this.sanitizer = sanitizer;
    }
    GraphTransformService.prototype.setSvgELementStyle = function (element, color, type) {
        var self = this;
        var svgEl = $(element.changingThisBreaksApplicationSecurity);
        var el = svgEl.find('[class]');
        if (type === 'canChangeFill') {
            el.css('fill', color);
        }
        if (type === 'canChangeStroke') {
            el.css('stroke', color);
        }
        if (type === 'canChangeStrokeWidth') {
            el.css('stroke-width', color);
        }
        return this.sanitizer.bypassSecurityTrustHtml(svgEl.prop('outerHTML'));
    };
    GraphTransformService = __decorate([
        Injectable()
    ], GraphTransformService);
    return GraphTransformService;
}());
export { GraphTransformService };
